export enum LegendState {
  ENTITIES = "entities",
  ADHOC_TEXT = "adHocText",
  CORPUS_BASELINE = "corpusBaseline",
  LINKS = "links",
}
